import React, { useState, useLayoutEffect } from "react";
import { Link } from "react-router-dom";

import { environments } from "../constants";
import HeadingOne from "../components/typography/HeadingOne";
import AuthForm from "../components/forms/AuthForm";
import AuthPageShell from "../components/forms/AuthPageShell";

const Index = () => {
  const allowedHosts = ["localhost", "dev-sso.tripplo.co", "staging-sso.tripplo.co"];
  const [isDev, setIsDev] = useState(false);

  const presetRouteTypes = {
    web: "app_type=web&route_type=signup&redirect_uri=https://app.tripplo.co",
    mobile: "app_type=mobile&route_type=signup&redirect_uri=https://app.tripplo.co"
  }

  useLayoutEffect(() => {
    if (allowedHosts.includes(window.location.hostname)) {
      setIsDev(true);
    }
  }, []);

  return (
    <AuthPageShell>
      <AuthForm>
        <HeadingOne className="text-[#003eb2] text-center text-2xl font-semibold mb-6">
          Tripplo Auth
        </HeadingOne>
        {isDev && (
          <div className="flex flex-col gap-4 text-sm font-poppins">
            <nav className="flex flex-wrap gap-x-3 gap-y-2 text-[#0458f6]">
              <Link className="hover:underline" to="/">Home</Link>
              <Link className="hover:underline" to={`/verification-step-one`}>Verification step</Link>
              <Link className="hover:underline" to={`/invite/brandon.williams@tripplo.co/06f04ccb-b7ce-4588-9e5d-c438b686a595`}>Invite member</Link>
              <Link className="hover:underline" to={`/forgot-password`}>Forgot password</Link>
            </nav>
            <nav className="flex flex-wrap gap-x-3 gap-y-2 text-[#0458f6]">
              <Link className="hover:underline" to={`/login/${environments.SERVICE_URL}/${environments.REACT_APP_DEPLOY_USER_POOL_WEB_CLIENT_ID}?${presetRouteTypes.mobile}`}>Login-Mobile</Link>
              <Link className="hover:underline" to={`/login/${environments.SERVICE_URL}/${environments.REACT_APP_DEPLOY_USER_POOL_WEB_CLIENT_ID}?${presetRouteTypes.web}`}>Login-Web</Link>
              <Link className="hover:underline" to="/login-redirect/serviceURL/token">Login Success</Link>
            </nav>
            <nav className="flex flex-wrap gap-x-3 gap-y-2 text-[#0458f6]">
              <Link className="hover:underline" to={`/signup/mobile-app?${presetRouteTypes.mobile}`}>Signup-Mobile</Link>
              <Link className="hover:underline" to={`/signup/web-app?${presetRouteTypes.web}`}>Signup-Web</Link>
              <Link className="hover:underline" to="/signup-redirect/serviceURL/token">Signup success</Link>
            </nav>
          </div>
        )}
      </AuthForm>
    </AuthPageShell>
  );
};

export default Index;
